import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const ShareIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M24.906 13.745v14.217H7.094V13.745M11.547 10.072 16 5.806l4.453 4.266M16 5.806v15.399"
    />
  </IconV2>
);

export default ShareIcon;
